// /sign-in — the Join landing with the sign-in module open, and the app's one
// sign-in page. Rendered by the _landing layout (JoinLanding reads the path);
// this route owns the path and validates the params JoinLanding forwards to the
// sign-in form: the invite bounce token and the drift-final reason. The
// post-sign-in destination (`next`) is validated by the _landing layout.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const signInSearchSchema = z.object({
  pendingInviteToken: z.string().min(1).optional(),
  reason: z.enum(['deactivated_expired', 'restricted']).optional(),
});

export const Route = createFileRoute('/_public/_landing/sign-in')({
  validateSearch: signInSearchSchema.parse,
  component: () => null,
});
